export default "__VITE_ASSET__B5vfR8hp__"